export const DECISION_IQ_SURVEY_QUERY_KEY = 'GET_DECISION_IQ_SURVEY';
export const DECISION_IQ_SURVEY_SUBMIT_KEY = 'PUT_DECISION_IQ_SURVEY';
